import { gql } from '@apollo/client';

/** 平铺部门列表，供其他页面复用 */
export const LIST_ALL_DEPTS = gql`
  query ListAllDepts {
    listAllDepts {
      id
      name
      fullName
      parentId
      warehouseList
      createdAt
      updatedAt
    }
  }
`;

export interface DeptFlatType {
  id: number | string;
  name: string;
  fullName?: string | null;
  parentId?: number | string | null;
  warehouseList?: number[];
  createdAt?: number | null;
  updatedAt?: number | null;
}

export interface ListAllDeptsResponse {
  listAllDepts: DeptFlatType[];
}
